var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93194 2.0025L8.75 2L8.56806 2.0025C5.06234 2.09884 2.25 4.97099 2.25 8.5C2.25 12.0899 5.16015 15 8.75 15C12.3399 15 15.25 12.0899 15.25 8.5C15.25 4.97099 12.4377 2.09884 8.93194 2.0025ZM3.25 8.5C3.25 5.51869 5.62208 3.0914 8.58185 3.00252L8.75 3L8.91815 3.00252C11.8779 3.0914 14.25 5.51869 14.25 8.5C14.25 11.5376 11.7876 14 8.75 14C5.71243 14 3.25 11.5376 3.25 8.5Z",
    fill: "#0A5190"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08325 4.6665C9.33638 4.6665 9.54558 4.85461 9.57869 5.09866L9.58325 5.1665V8.83317C9.58325 9.0863 9.39515 9.2955 9.1511 9.32861L9.08325 9.33317H6.08325C5.80711 9.33317 5.58325 9.10931 5.58325 8.83317C5.58325 8.58004 5.77135 8.37084 6.0154 8.33773L6.08325 8.33317H8.58325V5.1665C8.58325 4.91337 8.77135 4.70418 9.0154 4.67107L9.08325 4.6665Z",
    fill: "#0A5190"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.829cfb6866f08317f3420bb15f039856.svg";
export { ForwardRef as ReactComponent };